import React from 'react';
import PropTypes from 'prop-types';
import imgElemento from '../../assets/icons/elemento.png';
import imgEmpresa from '../../assets/icons/empresa.png';
import imgGraficas from '../../assets/icons/graficas.png';
import imgProyectos from '../../assets/icons/proyecto.png';
import imgReportes from '../../assets/icons/reportes.png';
import imgSensores from '../../assets/icons/sensor.png';
import imgTarjetas from '../../assets/icons/tarjeta.png';
import imgUsuarios from '../../assets/icons/user.png';
import imgLog from '../../assets/icons/log.png';
// import imgLogs from '../../assets/icons/logs.png'; // Descomenta cuando agregues el archivo

const imgPaths = {
  elemento: imgElemento,
  empresa: imgEmpresa,
  grafica: imgGraficas,
  dashboard: imgGraficas, // Usar el mismo ícono de gráficas para dashboard
  proyecto: imgProyectos,
  reporte: imgReportes,
  sensor: imgSensores,
  tarjeta: imgTarjetas,
  usuario: imgUsuarios,
  logs: imgLog,
};

const Icon = ({ name, size }) => (
  <div>
    <img src={imgPaths[`${name}`]} width={size} alt={name} />
  </div>
);

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
};
Icon.defaultProps = {
  size: 20
};

export default Icon;
